module.exports = __webpack_public_path__ + "assets/9ad83010d05ff95602c7fdb69b01c249.png";